import React from 'react'

export const ConditionalWrapper: React.FC<
	{
		condition?: boolean
	} & (
		| { Wrapper: React.FC }
		| { wrap: (children: React.ReactNode) => JSX.Element }
	)
> = ({ condition, children, ...wrapper }) => {
	if (!condition) {
		return <>{children}</>
	}
	if ('Wrapper' in wrapper) {
		return <wrapper.Wrapper>{children}</wrapper.Wrapper>
	}
	return wrapper.wrap(children)
}
